import Phaser from "phaser";

/** 初期化シーン → Menuへ遷移 */
export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: "BootScene" });
  }

  create(): void {
    this.scene.start("MenuScene");
  }
}
